import { createFileRoute } from '@tanstack/react-router';
import { Container, Stack, Text, Title } from '@mantine/core';
import { motion } from 'framer-motion';
import { PublicShell } from '../components/PublicShell';

function AboutPage() {
  return (
    <PublicShell>
      <Container size="md" py="xl">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
          <Stack gap="md">
            <Title order={2}>About LeadSync</Title>
            <Text>
              LeadSync helps businesses talk to their customers on the channels those customers
              already use — WhatsApp, Facebook Messenger, and Instagram. We obsess over reliability
              (every webhook persists before we 200), fairness (per-vendor isolation enforced at the
              database layer), and the humble parts of conversation tooling — keyboard shortcuts,
              search that finds the right message, exports that round-trip cleanly.
            </Text>
            <Text>
              We're an official Meta Tech Provider candidate; the platform is built around Meta's
              published API contracts and respects all rate-limit, retention, and data-deletion
              guidance.
            </Text>
          </Stack>
        </motion.div>
      </Container>
    </PublicShell>
  );
}

export const Route = createFileRoute('/about')({ component: AboutPage });
